import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const GENDER_OPTIONS = ["Gelding", "Mare", "Stallion", "Colt", "Filly"];

// Canonical option for a saved value; unknown legacy values are kept as-is.
export const normGender = (v) => GENDER_OPTIONS.find((o) => o.toLowerCase() === String(v || "").trim().toLowerCase()) || (v || "");

export function GenderSelect({ id, value, onChange, disabled, error, className = "h-11" }) {
  const v = normGender(value);
  const opts = v && !GENDER_OPTIONS.includes(v) ? [...GENDER_OPTIONS, v] : GENDER_OPTIONS;
  return (
    <Select value={v || undefined} onValueChange={onChange} disabled={disabled}>
      <SelectTrigger id={id} data-testid={id} aria-invalid={!!error} className={`${className} text-base bg-white ${error ? "border-red-500" : "border-stone-300"}`}>
        <SelectValue placeholder="Select gender" />
      </SelectTrigger>
      <SelectContent>
        {opts.map((o) => <SelectItem key={o} value={o} data-testid={`${id}-option-${o.toLowerCase()}`} className="min-h-[44px] text-base">{o}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}
